<template>
    <div class="main allergens-page">
        <div class="container">
            <p class="allergens-page__title small-title"> {{ $root.translations["allergens_text_2"] }} </p>
            <div class="tables">
                <div v-for="blocks, kk in categorized">
                    <table class="alltable">
                        <tbody>
                            <tr class="top-row">
                                <th colspan="4"></th>
                                <th v-for="allergen in allergens">
                                    <div class="">
                                        <span class="span-style">{{allergen}}</span>
                                    </div>
                                </th>
                            </tr>
                            <tr v-for="block, k in blocks">
                                <td :class="{pagebreak_: !!k}" v-if="block.type === 'label'" :colspan="allergens.length + 1 + 3"><b>{{block.name.trim() ? block.name : '(Uncategorized)'}}</b></td>
                                <td colspan="4" v-if="block.type !== 'label'">{{block.name}}</td>
                                <td v-if="block.type !== 'label'" v-for="allergen in allergens"><span v-if="block.allergens.includes(allergen)">+</span></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td :colspan="allergens.length + 1">
                                    <div class="footer-style">
                                        <div>
                                            {{ $root.translations["allergens_footer_disclaimer"] }} {{formatDate}}.
                                        </div>
                                        <div>
                                            Copyright © {{new Date().getFullYear()}} Circle K
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="pagebreak"></div>
                </div>
            </div>
        </div>
        <div class="divFooter footer-style">
            <div>
                {{ $root.translations["allergens_footer_disclaimer"] }} {{formatDate}}.
            </div>
            <div>
                Copyright © {{new Date().getFullYear()}} Circle K
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    name: "allergens2",
    data() {
        return {
            products: [],
            allergens: [],
        };
    },
    mounted() {
        this.getProducts();
    },

    computed: {
        formatDate() {
            var x = new Date()
            var y = 'yyyy-MM-dd hh:mm'

            var z = {
                M: x.getMonth() + 1,
                d: x.getDate(),
                h: x.getHours(),
                m: x.getMinutes(),
                s: x.getSeconds()
            };

            y = y.replace(/(M+|d+|h+|m+|s+)/g, function(v) {
                return ((v.length > 1 ? "0" : "") + z[v.slice(-1)]).slice(-2)
            });

            return y.replace(/(y+)/g, function(v) {
                return x.getFullYear().toString().slice(-v.length)
            });
        },
        categorized() {
            const categories = {}
            this.products.sort((a, b) => {
                if (a.category == b.category) {
                    return a.name < b.name ? -1 : 1
                }
                return a.category < b.category ? -1 : 1
            }).forEach(product => {
                if (!categories[product.category]) {
                    categories[product.category] = []
                }
                categories[product.category].push(product)
            });

            const list = Object.keys(categories).reduce((accumulator, currentValue) => {
                return [...accumulator, {
                    type: 'label',
                    name: currentValue
                }, ...categories[currentValue]]
            },[])

            const form = []
            for (var i = 0; i < list.length; i++) {
                if (list[i].type === 'label') {
                    form.push([])
                }
                form[form.length-1].push(list[i])
            }

            return form
            //
            // return Object.keys(categories).map(category => {
            //     return [name: category, items: categories[category]]
            // })
        },
    },
    methods: {
        getProducts(lang) {
          axios
            .get(`${this.$root.apiUrl}/getApiAlergensTable/${this.$route.params.lang}`)
            .then((response) => {
              this.products = response.data.products;
              this.allergens = response.data.allergens;
            });
        }
    },
};
</script>

<style lang="scss">
table.alltable {
    margin: 0;
    font-size: 75%;
    table-layout: fixed;
}
.alltable td {
    width: 5%;
}
.alltable td:first-child {
    width: 20%;
}
.span-style {
    line-height: 0;
}
.tables {
    margin-top: 20px;
    margin-bottom: 90px;
}
.alltable th {
    vertical-align: bottom;
    > div {
        > span {
            writing-mode: vertical-rl;
            // display: block;
            // text-align: right;
            white-space: nowrap;
            transform: rotate(-180deg);
        }
    }
}
table.alltable {
    border-collapse: collapse;
    border: 1px solid #ccc;
    width: 100%;
    border-left: 0;
    border-bottom: 0;
}
.alltable tbody {
    border-left: 1px solid #ccc;
}
table.alltable td{
    border: 1px solid #ccc;
    padding: 5px 0px;
}
table.alltable td:first-child{
    border-left: 0px solid #ccc;
}
table.alltable th{
   border: 1px solid #ccc;
   padding: 5px 0px;
}
.alltable td {
    text-align: center;
}
.alltable td:first-child {
    text-align: left;
    width: 240px;
    padding: 5px;
}
@media screen {
    .tables > div:not(:first-child) table .top-row {
        display: none;
    }
    tfoot {
        display: none;
    }
    div.divFooter {
        display: none;
    }
}
tfoot {
    opacity: 0;
    td {
        border-color: transparent !important;
    }
}
@media print {
    @page {
        size: portrait
    }
    .container {
        padding-bottom: 200px;
    }
    .allergens-page {
        padding-top: 0;
    }
    .footer-style {
        font-size: 0.7rem;
    }
    #block-copyright {
        display: none;
    }
    .tables,
    table {
        margin-bottom: 0;
    }
    div.divFooter {
        page-break-after: always;
        position: fixed;
        bottom: 0;
    }
    #header {
        position: static;
        height: 60px;
        .toolbar {
            display: none;
        }
    }
    .bottom-region {
        display: none;
    }
    #block-bottom a {
        display: none;
    }
    .pagebreak { page-break-before: always; } /* page-break-after works, as well */
}
</style>
